import React from 'react';

const Card = ({
  children,
  className = '',
  header,
  footer,
  padding = true
}) => {
  return (
    <div className={`card ${className}`}>
      {header && (
        <div className="card-header">
          {header}
        </div>
      )}

      <div className={padding ? 'card-body' : ''}>
        {children}
      </div>

      {footer && (
        <div className="card-footer">
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;